import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useUpdateBillingCompany = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base.put('/api/company/Put', model).then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            // The response contains only the changed field(s) (e.g. iban + bic), so merge.
            queryClient.setQueryData([LicenseQueryKey.BillingCompany], (old) => old ? Object.assign(Object.assign({}, old), result) : result);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateBillingCompany: mutateAsync, isUpdating: isLoading };
};
export default useUpdateBillingCompany;
